export default "__VITE_ASSET__CcXxkrdJ__"